import Mapper from '@web/mapper/Mapper'
import { UserPaymentMethod } from '@web/types/UserPaymentMethod'

export default class UserPaymentMethodMapper extends Mapper {
  static toClient (data: unknown): UserPaymentMethod {
    const convertedData = UserPaymentMethodMapper.converter({
      data
    }) as UserPaymentMethod

    return convertedData
  }
}
